module.exports = __webpack_public_path__ + "static/media/notifications.d9d8cd3d.svg";